export default __webpack_public_path__ + "static/media/front.21e20414.jpg";